import { formatPaywallCurrencyAmount } from "@/react/helpers/paywalls/currencies";
import { mapCurrencyAmountStrToInt } from "@circle-react/components/Paywalls/Admin/utils";
import { paywallPriceTypes } from "@circle-react/types/PaywallPrice";
import type {
  NoticeScenario,
  NoticeScenarioMatcher,
  NoticeScenarioMessagePropsResolver,
} from "../NoticeScenario.types";
import { installmentsStateValidator } from "./StateValidators";

const matcher: NoticeScenarioMatcher = ({
  priceType,
  hasUpfrontPayment,
  hasTrialPeriod,
}) =>
  priceType === paywallPriceTypes.installments &&
  !hasUpfrontPayment &&
  hasTrialPeriod;
const messagePropsResolver: NoticeScenarioMessagePropsResolver = ({
  buildOptions,
  currency,
  trialPeriodDays,
  watch,
}) => {
  const totalAmount = mapCurrencyAmountStrToInt(watch("amount"));
  const installmentsCount = parseInt(watch("installments_count"));
  const installmentAmount = Math.round(totalAmount / installmentsCount);
  return [
    "trial_then_installments",
    {
      installments_frequency:
        buildOptions.frequencies[
          watch("billing_frequency")
        ].as_adverb.toLowerCase(),
      installments_count: installmentsCount,
      installment_amount: formatPaywallCurrencyAmount(
        currency,
        installmentAmount,
      ),
      total_amount: formatPaywallCurrencyAmount(currency, totalAmount),
      trial_period_days: `${trialPeriodDays}`,
    },
  ];
};

export const trialThenInstallments: NoticeScenario = {
  matcher,
  stateValidator: installmentsStateValidator,
  messagePropsResolver,
};
